<template>
  <div class="home">
    <!-- 企业亮点 -->
    <StatBar :items="highlights" />

    <!-- 公司简介 -->
    <section id="company-intro" class="page-section company-intro">
      <SectionTitle title="公司简介" subtitle="专业环保设备设计、生产、维护" tag="About Us" />
      <div class="intro-grid">
        <div class="intro-grid__text">
          <span class="intro-grid__subtitle">广东中泉环保科技有限公司</span>
          <h3>集科研、设计、制造于一体的环保设备生力军</h3>
          <p>随着我国经济飞速发展，环境污染带来的健康问题也成为了重中之重。因此，绿色低碳工业体系是工业实现可持续发展的必然之路，广东中泉环保科技公司应运而生。</p>
          <p>广东中泉环保科技有限公司是一家集环保设备设计、生产、维护为一体的高新技术企业。公司自成立以来，以娴熟的技术、先进的工艺、严谨的态度和不断创新的理念，在废气治理、粉尘净化、酸碱处理等多个领域治理方面积累了丰富的行业经验，专业为广大环保设备工程企业提供最优质的环保设备及一站式配套服务。</p>
          <div class="intro-grid__features">
            <div class="feature-item">
              <span class="feature-item__icon">✔️</span>
              <span class="feature-item__text">高标准不锈钢精工制造</span>
            </div>
            <div class="feature-item">
              <span class="feature-item__icon">✔️</span>
              <span class="feature-item__text">高标准通水试压检测</span>
            </div>
            <div class="feature-item">
              <span class="feature-item__icon">✔️</span>
              <span class="feature-item__text">贴心周到的一站式配套服务</span>
            </div>
          </div>
          <router-link to="/introduce" class="btn-more-premium">了解更多关于我们 <i class="el-icon-right"></i></router-link>
        </div>
        <div class="intro-grid__img-wrapper">
          <div class="intro-grid__border-deco"></div>
          <b-carousel
            id="intro-carousel"
            class="intro-carousel"
            v-model="introSlide"
            :interval="4000"
            controls
            indicators
            fade
          >
            <b-carousel-slide v-for="(item, index) in introImages" :key="index">
              <template #img>
                <img :src="item.img" :alt="item.alt" class="intro-grid__img" />
              </template>
            </b-carousel-slide>
          </b-carousel>
          <div class="intro-grid__badge">
            <span class="num">100%</span>
            <span class="lbl">高标准交付</span>
          </div>
        </div>
      </div>
    </section>

    <!-- 产品介绍 -->
    <section class="page-section page-section--alt">
      <SectionTitle title="产品介绍" subtitle="高性价比环保设备，自主设计研发让您买得放心" tag="Core Products" />
      <b-row class="px-3">
        <b-col md="4" v-for="item in products" :key="item.id" class="mb-4 d-flex align-items-stretch">
          <ProductCard
            :img="item.img"
            :name="item.name"
            @click="goProDetail(item.id)"
          />
        </b-col>
      </b-row>
      <div class="text-center mt-3">
        <router-link to="/product" class="btn-more-premium">查看全部环保产品 <i class="el-icon-right"></i></router-link>
      </div>
    </section>

    <!-- 制造实力 -->
    <section class="page-section">
      <SectionTitle title="制造实力" :subtitle="company.certification" tag="Manufacturing Capacity" />
      <div class="factory-grid">
        <div v-for="(photo, index) in factoryPhotosWithDesc" :key="index" class="factory-grid__item">
          <img :src="photo.img" :alt="photo.alt" />
          <div class="factory-grid__caption">
            <h4>{{ photo.title }}</h4>
            <p>{{ photo.desc }}</p>
          </div>
        </div>
      </div>
    </section>

    <!-- 相关知识 -->
    <section class="page-section page-section--alt">
      <SectionTitle title="相关知识" subtitle="关注我们，了解更多行业环保标准与产品维护知识" tag="Industry Knowledge" />
      <b-row class="px-3">
        <b-col md="4" v-for="item in knows" :key="item.id" class="mb-4 d-flex align-items-stretch">
          <div class="news-card" @click="goKnowdetail(item.id)">
            <div class="news-card__body">
              <div class="news-card__top">
                <span class="news-card__badge">环保科普</span>
                <span class="news-card__time">📅 {{ item.time }}</span>
              </div>
              <h5>{{ item.title }}</h5>
              <p class="news-card__desc">{{ item.detail.p1 }}</p>
              <span class="news-card__link">阅读全文 <i class="el-icon-arrow-right"></i></span>
            </div>
          </div>
        </b-col>
      </b-row>
      <div class="text-center mt-3">
        <router-link to="/knows" class="btn-more-premium">了解更多知识 <i class="el-icon-right"></i></router-link>
      </div>
    </section>

    <!-- 电话联系 -->
    <section class="consult-section">
      <div class="consult-section__inner">
        <div class="consult-section__info">
          <span class="consult-section__tag">电话联系更高效</span>
          <h3>欢迎来电沟通设备选型与工程报价</h3>
          <p>如需了解产品规格、非标定制、工程配套或售后维护，请直接拨打服务电话。</p>
          <div class="consult-section__phones">
            <div v-for="(c, idx) in company.contacts" :key="idx" class="consult-section__phone-box">
              <span class="icon">📞</span>
              <div class="details">
                <span class="title">咨询热线 ({{ c.name }})</span>
                <a :href="'tel:' + c.phone" class="phone">{{ c.phone }}</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 联系我们 -->
    <section class="contact-section">
      <div class="contact-section__inner">
        <div class="contact-section__info-card">
          <ContactInfo />
        </div>
        <div class="contact-section__action-card">
          <span class="contact-section__tag">欢迎来厂考察</span>
          <h3>需要设备选型或工程报价？</h3>
          <p>把工况、尺寸、风量和处理要求告诉我们，技术顾问会尽快给出适配方案。</p>
          <router-link to="/contact" class="contact-section__btn">查看联系方式 <i class="el-icon-right"></i></router-link>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { COMPANY, FACTORY_PHOTOS, HIGHLIGHTS } from '@/constants/company'
import { KNOW_LIST, PRODUCT_LIST } from '@/constants/staticData'
import SectionTitle from '@/components/SectionTitle.vue'
import StatBar from '@/components/StatBar.vue'
import ProductCard from '@/components/ProductCard.vue'
import ContactInfo from '@/components/ContactInfo.vue'

export default {
  name: 'HomeView',
  components: { SectionTitle, StatBar, ProductCard, ContactInfo },
  data () {
    return {
      company: COMPANY,
      factoryPhotos: FACTORY_PHOTOS,
      highlights: HIGHLIGHTS,
      introSlide: 0,
      introImages: [
        { img: require('@/assets/photos/hero-9.jpg'), alt: '中泉环保高端设备制造' },
        { img: require('@/assets/photos/hero-6.jpg'), alt: '环保设备生产车间' },
        { img: require('@/assets/photos/hero-7.jpg'), alt: '不锈钢环保设备组装' },
        { img: require('@/assets/photos/hero-8.jpg'), alt: '工厂设备展示' }
      ],
      products: [],
      knows: [],
      // 更加丰富生动的制造实力描述
      factoryPhotosWithDesc: [
        {
          img: FACTORY_PHOTOS[0].img,
          alt: '环保设备生产车间',
          title: '标准化洁净车间',
          desc: '配置高精度折弯机、等离子切割等精良加工设备。'
        },
        {
          img: FACTORY_PHOTOS[1].img,
          alt: '不锈钢设备组装',
          title: '精益组装焊接',
          desc: '十年焊接老匠人，高标准氩弧焊确保焊缝均匀、滴水不漏。'
        },
        {
          img: FACTORY_PHOTOS[2].img,
          alt: '工厂设备展示',
          title: '核心环保设备制造',
          desc: '生物滴滤塔、活性炭箱等产品源头自主生产，去中间商低价高质。'
        },
        {
          img: FACTORY_PHOTOS[3].img,
          alt: '成品设备出厂',
          title: '严格出厂质检',
          desc: '每台喷淋塔和一体机都经过通水试压，严格做好防漏与质量检查，高标准打包发货。'
        }
      ]
    }
  },
  created () {
    this.getProList()
    this.getKnowList()
  },
  methods: {
    getProList () {
      this.products = PRODUCT_LIST.slice(0, 3)
    },
    goProDetail (id) {
      this.$router.push({ path: `/prodetail/${id}` })
    },
    getKnowList () {
      this.knows = KNOW_LIST.slice(0, 3)
    },
    goKnowdetail (id) {
      this.$router.push({ path: `/knowdetail/${id}` })
    }
  }
}
</script>

<style lang="scss" scoped>
.home {
  background:
    radial-gradient(circle at 8% 8%, rgba(16, 185, 129, 0.08), transparent 26rem),
    linear-gradient(180deg, #ffffff 0%, #f8fbfa 100%);
}

.company-intro {
  margin-top: var(--nav-height);
  scroll-margin-top: calc(var(--nav-height) + 1rem);
}

.intro-grid {
  display: grid;
  grid-template-columns: 1.1fr 0.9fr;
  gap: 4rem;
  align-items: center;

  &__text {
    text-align: left;

    h3 {
      font-size: 1.875rem;
      font-weight: 700;
      color: var(--color-dark);
      margin-bottom: 1.25rem;
      line-height: 1.4;
    }

    p {
      line-height: 1.8;
      color: var(--color-text-muted);
      margin-bottom: 1.25rem;
      font-size: 1.02rem;
    }
  }

  &__subtitle {
    font-size: 0.85rem;
    font-weight: 700;
    color: var(--color-primary);
    text-transform: uppercase;
    letter-spacing: 0.1em;
    display: block;
    margin-bottom: 0.5rem;
  }

  &__features {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
    margin: 1.5rem 0 2rem;

    .feature-item {
      display: flex;
      align-items: center;
      gap: 0.75rem;

      &__icon {
        font-size: 0.95rem;
        background: var(--color-primary-light);
        color: var(--color-primary);
        width: 1.75rem;
        height: 1.75rem;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 50%;
      }

      &__text {
        font-size: 0.95rem;
        font-weight: 600;
        color: var(--color-dark-muted);
      }
    }
  }

  &__img-wrapper {
    position: relative;
    padding-left: 1.25rem;
    padding-bottom: 1.25rem;
  }

  &__border-deco {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 85%;
    height: 85%;
    border: 4px solid var(--color-primary-light);
    border-radius: var(--radius-md);
    z-index: 1;
  }

  &__img {
    width: 100%;
    height: 100%;
    border-radius: var(--radius-md);
    box-shadow: var(--shadow-lg);
    position: relative;
    z-index: 2;
    aspect-ratio: 4 / 3;
    object-fit: cover;
    transition: transform 0.4s;

    &:hover {
      transform: scale(1.02);
    }
  }

  &__badge {
    position: absolute;
    right: -1rem;
    top: -1rem;
    background: var(--color-primary);
    color: #fff;
    padding: 1rem;
    border-radius: var(--radius-md);
    box-shadow: var(--shadow-md);
    z-index: 3;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border: 2px solid #fff;

    .num {
      font-size: 1.5rem;
      font-weight: 800;
      line-height: 1;
    }
    .lbl {
      font-size: 0.75rem;
      font-weight: 600;
      opacity: 0.9;
    }
  }
}

.intro-carousel {
  position: relative;
  z-index: 2;

  ::v-deep .carousel-inner,
  ::v-deep .carousel-item {
    border-radius: var(--radius-md);
    aspect-ratio: 4 / 3;
    overflow: hidden;
  }

  ::v-deep .carousel-control-prev,
  ::v-deep .carousel-control-next {
    width: 12%;
    opacity: 0.9;
  }

  ::v-deep .carousel-control-prev-icon,
  ::v-deep .carousel-control-next-icon {
    width: 2.25rem;
    height: 2.25rem;
    border-radius: 50%;
    background-color: rgba(6, 78, 59, 0.6);
    background-size: 45%;
  }

  ::v-deep .carousel-indicators {
    margin-bottom: 0.75rem;
  }
}

.factory-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1.5rem;
  padding: 0 1.5rem;

  &__item {
    border-radius: var(--radius-md);
    overflow: hidden;
    aspect-ratio: 4/3;
    box-shadow: var(--shadow-sm);
    position: relative;
    cursor: pointer;
    border: 1px solid var(--color-border);

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      transition: transform 0.6s cubic-bezier(0.165, 0.84, 0.44, 1);
    }

    &:hover {
      img {
        transform: scale(1.08);
      }
      .factory-grid__caption {
        transform: translateY(0);
      }
    }
  }

  &__caption {
    position: absolute;
    inset: auto 0 0 0;
    background: linear-gradient(to top, rgba(6, 78, 59, 0.95) 0%, rgba(6, 78, 59, 0.7) 70%, transparent 100%);
    padding: 1.25rem;
    color: #fff;
    text-align: left;
    transform: translateY(calc(100% - 3.25rem));
    transition: transform 0.4s cubic-bezier(0.165, 0.84, 0.44, 1);
    backdrop-filter: blur(1px);

    h4 {
      font-size: 1rem;
      font-weight: 700;
      margin-bottom: 0.5rem;
      color: #fff;
      display: flex;
      justify-content: space-between;
      align-items: center;

      &::after {
        content: '▲';
        font-size: 0.7rem;
        opacity: 0.7;
      }
    }

    p {
      font-size: 0.8rem;
      line-height: 1.5;
      margin: 0;
      color: rgba(255, 255, 255, 0.85);
    }
  }
}

.news-card {
  background:
    linear-gradient(135deg, rgba(240, 253, 244, 0.95), rgba(255, 255, 255, 0.96)),
    #fff;
  border-radius: var(--radius-lg);
  box-shadow: 0 14px 32px rgba(6, 78, 59, 0.08);
  overflow: hidden;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.165, 0.84, 0.44, 1);
  height: 100%;
  border: 1px solid rgba(16, 185, 129, 0.14);
  display: flex;
  flex-direction: column;
  position: relative;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 4px;
    background: linear-gradient(90deg, var(--color-primary), var(--color-accent));
  }

  &:hover {
    transform: translateY(-6px);
    box-shadow: var(--shadow-lg);
    border-color: var(--color-primary);

    .news-card__link {
      color: var(--color-primary);
    }
  }

  &__badge {
    background: rgba(16, 185, 129, 0.12);
    color: var(--color-primary-dark);
    font-size: 0.75rem;
    font-weight: 700;
    padding: 0.28rem 0.75rem;
    border-radius: 999px;
    border: 1px solid rgba(16, 185, 129, 0.18);
  }

  &__body {
    padding: 1.5rem;
    text-align: left;
    display: flex;
    flex-direction: column;
    gap: 0.8rem;
    flex-grow: 1;

    h5 {
      font-weight: 700;
      font-size: 1.1rem;
      color: var(--color-dark);
      margin: 0;
      line-height: 1.45;
      min-height: 3.15rem;
    }
  }

  &__top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 1rem;
  }

  &__time {
    color: var(--color-text-light);
    font-size: 0.8rem;
    font-weight: 500;
    white-space: nowrap;
  }

  &__desc {
    color: var(--color-text-muted);
    margin: 0;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    font-size: 0.9rem;
    line-height: 1.65;
  }

  &__link {
    font-size: 0.85rem;
    font-weight: 700;
    color: var(--color-text-light);
    margin-top: auto;
    padding-top: 0.75rem;
    display: inline-flex;
    align-items: center;
    gap: 0.25rem;
    transition: color 0.2s;
  }
}

.consult-section {
  background: linear-gradient(135deg, var(--color-dark) 0%, var(--color-dark-muted) 100%);
  padding: 4rem 1.5rem;
  border-top: 1px solid rgba(255, 255, 255, 0.05);

  &__inner {
    max-width: var(--max-width);
    margin: 0 auto;
    display: flex;
    justify-content: center;
  }

  &__info {
    text-align: center;
    color: #fff;
    display: flex;
    flex-direction: column;
    gap: 1rem;
    align-items: center;
    max-width: 54rem;

    h3 {
      font-size: 2rem;
      font-weight: 700;
      margin: 0;
      color: #fff;
      line-height: 1.35;
    }

    p {
      font-size: 1.05rem;
      opacity: 0.85;
      line-height: 1.6;
      margin: 0;
    }
  }

  &__tag {
    font-size: 0.8rem;
    font-weight: 700;
    color: var(--color-accent);
    letter-spacing: 0.15em;
    text-transform: uppercase;
  }

  &__phones {
    display: grid;
    grid-template-columns: repeat(2, minmax(16rem, 1fr));
    gap: 1rem;
    margin: 1rem 0 0;
    width: 100%;
  }

  &__phone-box {
    display: flex;
    align-items: center;
    gap: 1.25rem;
    background: rgba(255, 255, 255, 0.08);
    border-radius: var(--radius-md);
    padding: 1.25rem 1.5rem;
    border: 1px solid rgba(255, 255, 255, 0.1);
    justify-content: center;

    .icon {
      font-size: 2.25rem;
      line-height: 1;
    }
    .details {
      display: flex;
      flex-direction: column;
      text-align: left;

      .title {
        font-size: 0.8rem;
        color: rgba(255, 255, 255, 0.65);
        font-weight: 600;
        margin: 0;
      }
      .phone {
        font-size: 1.75rem;
        font-weight: 800;
        color: var(--color-accent);
        text-decoration: none;
        margin: 0;
        line-height: 1.1;

        &:hover {
          color: #fff;
        }
      }
    }
  }
}

.contact-section {
  padding: 4rem 1.5rem 4.5rem;
  background:
    linear-gradient(135deg, rgba(240, 253, 244, 0.9) 0%, rgba(255, 255, 255, 0.98) 100%);

  &__inner {
    max-width: var(--max-width);
    margin: 0 auto;
    display: grid;
    grid-template-columns: 1.1fr 0.9fr;
    gap: 2rem;
    align-items: stretch;
  }

  &__info-card {
    background: #fff;
    border-radius: var(--radius-lg);
    padding: 2.5rem;
    box-shadow: var(--shadow-md);
    border: 1px solid rgba(16, 185, 129, 0.12);
    display: flex;
    align-items: center;
  }

  &__action-card {
    border-radius: var(--radius-lg);
    padding: 2.5rem;
    background: linear-gradient(135deg, var(--color-dark) 0%, var(--color-dark-muted) 100%);
    color: #fff;
    text-align: left;
    box-shadow: var(--shadow-lg);
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 1rem;
    position: relative;
    overflow: hidden;

    &::after {
      content: '';
      position: absolute;
      right: -4rem;
      bottom: -4rem;
      width: 12rem;
      height: 12rem;
      border-radius: 50%;
      background: rgba(255, 255, 255, 0.08);
    }

    h3 {
      margin: 0;
      font-size: 1.75rem;
      line-height: 1.35;
      font-weight: 800;
      color: #fff;
      position: relative;
      z-index: 1;
    }

    p {
      margin: 0;
      line-height: 1.7;
      color: rgba(255, 255, 255, 0.82);
      position: relative;
      z-index: 1;
    }
  }

  &__tag {
    color: var(--color-accent);
    font-size: 0.8rem;
    font-weight: 800;
    letter-spacing: 0.12em;
    position: relative;
    z-index: 1;
  }

  &__btn {
    width: fit-content;
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.75rem 1.5rem;
    border-radius: var(--radius-sm);
    background: var(--color-accent);
    color: #fff;
    font-weight: 700;
    text-decoration: none;
    position: relative;
    z-index: 1;
    transition: all 0.25s;

    &:hover {
      color: #fff;
      text-decoration: none;
      background: var(--color-accent-dark);
      transform: translateY(-2px);
    }
  }
}

.btn-more-premium {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 2rem;
  background: transparent;
  color: var(--color-primary);
  border: 2px solid var(--color-primary);
  border-radius: var(--radius-sm);
  font-weight: 700;
  font-size: 0.95rem;
  text-decoration: none;
  transition: all 0.3s cubic-bezier(0.165, 0.84, 0.44, 1);
  cursor: pointer;

  i {
    transition: transform 0.2s;
  }

  &:hover {
    background: var(--color-primary);
    color: #fff;
    text-decoration: none;
    box-shadow: 0 4px 12px rgba(16, 185, 129, 0.25);

    i {
      transform: translateX(4px);
    }
  }
}

@keyframes fade-in-up-custom {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@media (max-width: 992px) {
  .intro-grid {
    grid-template-columns: 1fr;
    gap: 3rem;
  }

  .factory-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 1rem;
    padding: 0;
  }

  .consult-section__inner {
    display: block;
  }

  .consult-section__phones {
    grid-template-columns: 1fr;
  }

  .contact-section__inner {
    grid-template-columns: 1fr;
    gap: 2rem;
  }
}

@media (max-width: 576px) {
  .factory-grid {
    grid-template-columns: 1fr;
  }

  .consult-section__phone-box {
    align-items: flex-start;
    justify-content: flex-start;
  }
}
</style>
